import httpClient from "@/api/httpClient";
import CalendarExportResponse from "@/model/CalendarExportResponse";
import CalendarFeedRequest from "@/model/CalendarFeedRequest";
import CalendarFeedResponse from "@/model/CalendarFeedResponse";

function getExport(
  accessToken: string,
  propertyId: string
): Promise<CalendarExportResponse> {
  return httpClient.getJson<CalendarExportResponse>(
    `/api/properties/${propertyId}/calendar-export`,
    accessToken
  );
}

function rotateExport(
  accessToken: string,
  propertyId: string
): Promise<CalendarExportResponse> {
  return httpClient.postJson<CalendarExportResponse>(
    `/api/properties/${propertyId}/calendar-export/rotate`,
    {},
    accessToken
  );
}

function listFeeds(
  accessToken: string,
  propertyId: string
): Promise<CalendarFeedResponse[]> {
  return httpClient.getJson<CalendarFeedResponse[]>(
    `/api/properties/${propertyId}/calendar-feeds`,
    accessToken
  );
}

function createFeed(
  accessToken: string,
  propertyId: string,
  request: CalendarFeedRequest
): Promise<CalendarFeedResponse> {
  return httpClient.postJson<CalendarFeedResponse>(
    `/api/properties/${propertyId}/calendar-feeds`,
    request,
    accessToken
  );
}

function syncFeed(
  accessToken: string,
  propertyId: string,
  feedId: string
): Promise<CalendarFeedResponse> {
  return httpClient.postJson<CalendarFeedResponse>(
    `/api/properties/${propertyId}/calendar-feeds/${feedId}/sync`,
    {},
    accessToken
  );
}

function deleteFeed(
  accessToken: string,
  propertyId: string,
  feedId: string
): Promise<void> {
  return httpClient.deleteNoContent(
    `/api/properties/${propertyId}/calendar-feeds/${feedId}`,
    accessToken
  );
}

const calendarsApi = {
  getExport,
  rotateExport,
  listFeeds,
  createFeed,
  syncFeed,
  deleteFeed,
};

export default calendarsApi;
